import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";

class ChargeUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const charge: ChargeInterface = ChargeFactory.create(props.res);
    if (charge?.contractId) {
      this.props.dispatch({
        type: Constants.PAGE_CONTRACT_UPDATE_HAS_CHARGES_CHANGES,
        payload: {
          contractId: charge?.contractId
        }
      }); 
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UPDATE_SUCCESS,
      payload: {
        charge: charge
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })
  }
}

export { ChargeUpdate };
